import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { LAST_MODIFIED_DATE } from 'customer-data-objects/task/TaskPropertyNames';
import TimezoneTypes from 'I18n/constants/TimezoneTypes';
import DateTimeCell from './DateTimeCell';
import { jsx as _jsx } from "react/jsx-runtime";
const TaskLastModifiedDateCell = ({
  original: cdtTask
}) => {
  const lastModifiedDate = getProperty(cdtTask, LAST_MODIFIED_DATE);
  return /*#__PURE__*/_jsx(DateTimeCell, {
    format: "LLL",
    i18nTimezoneType: TimezoneTypes.USER,
    value: lastModifiedDate
  });
};
export default TaskLastModifiedDateCell;